/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetAvailableStatesResponse, GetEncountersAvailableStatesParams } from './api.schemas';

import { api } from '../util/http';

export const getEncountersAvailableStates = (
  params?: GetEncountersAvailableStatesParams,
  signal?: AbortSignal,
) => {
  return api<GetAvailableStatesResponse>({
    url: `/api/encounters/available-states`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetEncountersAvailableStatesQueryKey = (
  params?: GetEncountersAvailableStatesParams,
) => {
  return [`/api/encounters/available-states`, ...(params ? [params] : [])] as const;
};

export const getGetEncountersAvailableStatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersAvailableStates>>,
  TError = unknown,
>(
  params?: GetEncountersAvailableStatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersAvailableStates>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersAvailableStatesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncountersAvailableStates>>> = ({
    signal,
  }) => getEncountersAvailableStates(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersAvailableStates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersAvailableStatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersAvailableStates>>
>;
export type GetEncountersAvailableStatesQueryError = unknown;

export function useGetEncountersAvailableStates<
  TData = Awaited<ReturnType<typeof getEncountersAvailableStates>>,
  TError = unknown,
>(
  params: undefined | GetEncountersAvailableStatesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersAvailableStates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersAvailableStates>>,
          TError,
          Awaited<ReturnType<typeof getEncountersAvailableStates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersAvailableStates<
  TData = Awaited<ReturnType<typeof getEncountersAvailableStates>>,
  TError = unknown,
>(
  params?: GetEncountersAvailableStatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersAvailableStates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersAvailableStates>>,
          TError,
          Awaited<ReturnType<typeof getEncountersAvailableStates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersAvailableStates<
  TData = Awaited<ReturnType<typeof getEncountersAvailableStates>>,
  TError = unknown,
>(
  params?: GetEncountersAvailableStatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersAvailableStates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersAvailableStates<
  TData = Awaited<ReturnType<typeof getEncountersAvailableStates>>,
  TError = unknown,
>(
  params?: GetEncountersAvailableStatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersAvailableStates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersAvailableStatesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
